


import React, { useState } from "react";
import { MapContainer, TileLayer, Marker, Popup as Pop, FeatureGroup, Polyline, Tooltip, LayersControl, LayerGroup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css"
import Popup from 'reactjs-popup'
import flag from './dot.png'
import { Loading } from "../../Helper/Loading";
import ViewURL from "../ViewURL/ViewURL";
import { useAuthState } from "../../Helper/Context";

const pin = "assets/img/marker.png"

const MapView4 = (props) => {
    const { handleCloseMap, ShowMap, LocationData } = props

    // console.log('LocationData', LocationData)

    const userDetails = useAuthState();
    const { username } = userDetails

    const [Loader, setLoading] = useState(false)

    const pinMB = L.icon({
        iconUrl: pin,
        iconSize: [27, 42],
        iconAnchor: [16, 40],
        popupAnchor: [0, -32],
        shadowUrl: null,
        shadowSize: null,
        shadowAnchor: null
    });


    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [ImagePopUpData, setImagePopUpData] = React.useState('')

    const handleShowImage = (img) => {
        setshowImagePopup(true)
        setImagePopUpData(img)
    }

    return (
        <>
            <Popup className='assigns' open={ShowMap} closeOnDocumentClick={false}
                onClose={handleCloseMap}
                contentStyle={{ overflowY: 'auto', overflowX: 'auto', height: '95vh' }}
            >

                <div className="call d-flex justify-content-between mb-2">
                    <h5> Track Location</h5>

                    <span className="close" onClick={handleCloseMap}
                        style={{ cursor: 'pointer' }}
                    >
                        &times;
                    </span>
                </div>
                <div className="modal-body" >
                    {
                        Loader ? <Loading />
                            :
                            <MapContainer
                                center={[LocationData && LocationData?.[0].assetLatitude, LocationData && LocationData?.[0].assetLongitude]}
                                zoom={12}
                                scrollWheelZoom={true}
                                style={{ height: "80vh" }}
                            >
                                {/* <TileLayer
                                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                    url="https://{s}.tile.osm.org/{z}/{x}/{y}.png"
                                /> */}

                                <LayersControl>
                                    <LayersControl.BaseLayer name="Open Street Map">
                                        <TileLayer
                                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                        />
                                    </LayersControl.BaseLayer>

                                    <LayersControl.BaseLayer name="Google Map">
                                        <TileLayer
                                            attribution="Google Maps"
                                            url="https://www.google.cn/maps/vt?lyrs=m@189&gl=cn&x={x}&y={y}&z={z}"
                                        />
                                    </LayersControl.BaseLayer>

                                    <LayersControl.BaseLayer checked name="Google Map Satellite">
                                        <LayerGroup>
                                            <TileLayer
                                                attribution="Google Maps Satellite"
                                                url="https://www.google.cn/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}"
                                            />
                                            <TileLayer url="https://www.google.cn/maps/vt?lyrs=y@189&gl=cn&x={x}&y={y}&z={z}" />
                                        </LayerGroup>
                                    </LayersControl.BaseLayer>

                                </LayersControl>

                                <FeatureGroup>
                                    {
                                        LocationData && LocationData.length > 0 && LocationData.map((item, j) => {
                                            return (

                                                <Marker
                                                    key={j}
                                                    position={[item?.assetLatitude, item?.assetLongitude]}
                                                    icon={pinMB}
                                                >

                                                    <Tooltip direction="top" offset={[0, -41]} opacity={1} permanent>
                                                        {item.assetName ? item.assetName : "-"}

                                                        <Pop>

                                                            <div className='marker-popup py-2'>

                                                                <b style={{ fontSize: '15px' }}>{item.assetName ? item.assetName : "-"}</b>
                                                                <hr style={{ marginTop: '5px' }} />

                                                                <div className='row my-2'>
                                                                    <div className='col-5'>Ward Name</div>
                                                                    <div className='col-1'>:</div>
                                                                    <div className='col-6'> <b>{item && item.wardName ? item.wardName : "-"}</b></div>
                                                                </div>

                                                                <div className='row my-2'>
                                                                    <div className='col-5'>Sector Name</div>
                                                                    <div className='col-1'>:</div>
                                                                    <div className='col-6'> <b>{item && item.sectorName ? item.sectorName : "-"}</b></div>
                                                                </div>

                                                                {/* <div className='row '>
                                                                    <div className='col-5'>Area Name</div>
                                                                    <div className='col-1'>:</div>
                                                                    <div className='col-6'> <b>{item && item.areaName ? item.areaName : "-"}</b></div>
                                                                </div> */}

                                                                <div className='row my-2'>
                                                                    <div className='col-5'>Lattitude</div>
                                                                    <div className='col-1'>:</div>
                                                                    <div className='col-6'> <b>{item && item.assetLatitude ? item.assetLatitude : "-"}</b></div>
                                                                </div>
                                                                <div className='row my-2'>
                                                                    <div className='col-5'>Longitude</div>
                                                                    <div className='col-1'>:</div>
                                                                    <div className='col-6'> <b>{item && item.assetLongitude ? item.assetLongitude : "-"}</b></div>
                                                                </div>
                                                                <div className='row my-2'>
                                                                    <div className='col-5'>Contractor Name</div>
                                                                    <div className='col-1'>:</div>
                                                                    <div className='col-6' style={{ fontSize: '12px' }}> <b>{item && item.contractorName ? item.contractorName : "-"}</b></div>
                                                                </div>
                                                                {
                                                                    item.assetPhoto && item.assetPhoto != '' &&
                                                                    <div className='row'>
                                                                        <div className='col-5'>Asset Image</div>
                                                                        <div className='col-1'>:</div>
                                                                        <div className='col-6'>
                                                                            <span className='cursor-pointer' onClick={() => window.open(item.assetPhoto)}>
                                                                                <i className="fa-solid fa-image fs-6 "></i>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                }

                                                            </div>
                                                        </Pop>
                                                    </Tooltip>

                                                </Marker>
                                            )
                                        })
                                    }
                                </FeatureGroup>

                            </MapContainer>
                    }

                </div>
                {
                    showImagePopup ?
                        <ViewURL
                            Heading="Image PopUp"
                            setshowImagePopup={setshowImagePopup}
                            ImagePopUpData={ImagePopUpData}

                        />
                        : ''


                }
            </Popup>
        </>
    );
}


export default MapView4;
